module.exports = __webpack_public_path__ + "media/logo.0c715fbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 15
// module chunks = 0